/* Woof & Whiskers — theme.js */
(function () {
  'use strict';

  function formatMoney(cents) {
    // Shopify cents -> £X.XX (falls back to simple £ format if Shopify.formatMoney not available)
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_format || '£{{amount}}'); } catch (e) {}
    }
    var n = (parseInt(cents, 10) || 0) / 100;
    return '£' + n.toFixed(2);
  }

  // ---------- Mobile menu toggle ----------
  var menuToggle = document.querySelector('.header__menu-toggle');
  var nav = document.querySelector('.header__nav');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', nav.classList.contains('is-open'));
    });
  }

  // ---------- Quantity selectors ----------
  document.querySelectorAll('.product__quantity').forEach(function (qty) {
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    var input = qty.querySelector('input[type="number"]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = parseInt(input.value, 10) || 1;
      input.value = v + 1;
    });
  });

  // ---------- Gallery thumbnails (non-variant manual clicks) ----------
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-main-image]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (mainImg && src) mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  // ---------- Product variant switching ----------
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var dataEl = section.querySelector('[data-product-json]');
    if (!dataEl) return;

    var productData;
    try {
      productData = JSON.parse(dataEl.textContent);
    } catch (err) {
      console.warn('Could not parse product JSON', err);
      return;
    }
    if (!productData || !Array.isArray(productData.variants) || !productData.variants.length) return;

    var optionGroups = section.querySelectorAll('[data-option-index]');
    var priceEl      = section.querySelector('[data-price]');
    var compareEl    = section.querySelector('[data-compare-price]');
    var variantInput = section.querySelector('[data-variant-id]');
    var mainImage    = section.querySelector('[data-main-image]');
    var submitBtn    = section.querySelector('[data-add-to-cart]');
    var submitText   = section.querySelector('[data-add-to-cart-text]');

    // Initialise selected options from the currently active buttons
    function getSelectedOptions() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var activeBtn = group.querySelector('.product__option.is-active');
        selected[idx] = activeBtn ? activeBtn.getAttribute('data-option-value') : null;
      });
      return selected;
    }

    function findMatchingVariant(selectedOptions) {
      return productData.variants.find(function (v) {
        return (v.options || []).every(function (opt, i) { return opt === selectedOptions[i]; });
      });
    }

    function updateVariant() {
      var selectedOptions = getSelectedOptions();
      var variant = findMatchingVariant(selectedOptions);

      if (!variant) {
        if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
        if (submitText) submitText.textContent = 'Unavailable';
        return;
      }

      // Update hidden variant ID
      if (variantInput) variantInput.value = variant.id;

      // Update URL without reloading, so refresh preserves variant
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      // Update price
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      // Update compare-at price
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
          compareEl.textContent = '';
        }
      }

      // Update main image if the variant has its own featured image
      if (mainImage && variant.featured_image && variant.featured_image.src) {
        var src = variant.featured_image.src;
        // Upgrade the width parameter if present
        if (src.indexOf('?') === -1) {
          src = src + '?width=1200';
        }
        mainImage.src = src;
        if (variant.featured_image.alt) mainImage.alt = variant.featured_image.alt;
      }

      // Update button availability
      if (submitBtn && submitText) {
        if (variant.available) {
          submitBtn.removeAttribute('disabled');
          submitText.textContent = 'Add to cart';
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
          submitText.textContent = 'Sold out';
        }
      }
    }

    // Wire up option button clicks
    optionGroups.forEach(function (group) {
      var buttons = group.querySelectorAll('[data-option-button]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          updateVariant();
        });
      });
    });

    // Run once on load in case URL has a variant param to sync with
    updateVariant();
  });

})();
